import { FC, memo, useMemo } from 'react';

import { Avatar } from 'react-activity-feed';

import { getTimeFromNow } from '../../../utils/time';
import { getActorName } from '../../../utils/feeds';

import { Activities } from '../../../types/feed';

import avatar from '../../../images/avatar.png';

import styles from './AggregatedActivity.module.css';

export type Props = {
  activity: Activities;
};

const AggregatedActivityComponent: FC<Props> = (activityProps) => {
  const { activity } = activityProps;

  const activityTime = useMemo(() => {
    return getTimeFromNow(activity?.updated_at);
  }, [activity?.updated_at]);

  const mainActor = activity.activities[0]?.actor;

  const otherActorsContent =
    activity.actor_count > 1
      ? ` and ${activity.actor_count - 1} ${
          activity.actor_count - 1 === 1 ? 'other' : 'others'
        }`
      : null;

  const complement = activity.verb === 'watch' ? 'videos' : 'times';

  const content = `${activity.verb}ed ${activity.activity_count} ${complement}`;

  const mainActorName = getActorName(mainActor);

  return (
    <div key={activity.time} className={styles.feedsGetStartedActivity}>
      <div className={styles.feedsGetStartedActivityAvatar}>
        <Avatar
          size={40}
          circle
          image={mainActor?.data?.profileImage || avatar}
        />
      </div>
      <div className={styles.feedsGetStartedActivityContent}>
        <div className={styles.feedsGetStartedActivityHeader}>
          <p className={styles.feedsGetStartedActivityUsername}>
            {mainActorName}{' '}
            <span className={styles.feedsGetStartedActivityHandle}>
              {otherActorsContent}
            </span>
          </p>
          <span className={styles.feedsGetStartedActivityTimestamp}>
            {activityTime || '00:00'}
          </span>
        </div>
        <p className={styles.feedsGetStartedActivityTweet}>{content}</p>
      </div>
    </div>
  );
};

export const AggregatedActivity = memo(AggregatedActivityComponent);
